import notification from 'antd/es/notification/index.js';
import {
  first_floor_filter,
  house_type_filter,
  mortgage_filter,
  owner_filter,
  price_filter,
  renovation_level_filter,
  residential_complex_filter,
  rooms_filter,
  square_filter,
  tour_filter,
  year_filter,
} from './filters.js';

export const filterPoints = (points, filters) => {
  const filteredPoints = points.filter((item) => {
    if (!residential_complex_filter(item, filters)) return false;
    if (!rooms_filter(item, filters)) return false;
    if (!price_filter(item, filters)) return false;
    if (!renovation_level_filter(item, filters)) return false;
    if (!house_type_filter(item, filters)) return false;
    if (!square_filter(item, filters)) return false;
    // if (!year_filter(item, filters)) return false;
    if (!owner_filter(item, filters)) return false;
    if (!mortgage_filter(item, filters)) return false;
    if (!tour_filter(item, filters)) return false;
    if (!first_floor_filter(item, filters)) return false;
    return true;
  });

  if (filteredPoints.length === 0) {
    notification.config({
      maxCount: 1,
      duration: 3,
    });
    notification.info({
      message: 'Info',
      description: 'По данному запросу не найдено квартир',
      placement: 'topRight',
      className: 'notification',
    });
  }

  return filteredPoints;
};
